import React, { useCallback, useContext } from 'react'
import { useAction } from '../../utils/react-redux'
import { getImageUrl } from '../../utils/image'
import s from './GeoentityBlockOffers.less'
import { loadGeoentityTabForAppId } from '../../../store/geoentity/geoentity.actions'
import { ScrollContext } from '../../genericComponents/ResponsiveScrollableWrapper/ResponsiveScrollableWrapper'
import RectangleActionButton, { COLOR_GREY_EMPTY } from '../../genericComponents/buttons/RectangleActionButton'

function Offer({ teaser, brand, bookUrl, details, appId }) {
  const loadTab = useAction(loadGeoentityTabForAppId)
  const scrollContext = useContext(ScrollContext)

  const onInfoClick = useCallback(() => {
    loadTab(appId).then(() => {
      scrollContext.scrollTop()
    })
  }, [scrollContext, loadTab, appId])

  return (
    <div className={s.row}>
      <span className={s.illustration}>
        <img className={s.image} src={getImageUrl(brand)} />
      </span>
      <span className={s.teaser}>{teaser}</span>
      <RectangleActionButton className={s.infos} color={COLOR_GREY_EMPTY} label="+ d'infos" onClick={onInfoClick} />
    </div>
  )
}

export default function GeoentityBlockOffers(props) {
  const { data } = props
  const { offers = [] } = data
  return (
    <div>
      {offers.map((offer, idx) => (
        <Offer key={idx} {...offer} />
      ))}
    </div>
  )
}
